import { AchievementName } from '@helios/achievement';
import classNames from 'classnames';
import { useTranslation } from '@helios/frontend-core';
import {
  achievedLocaleMap,
  achievedTargetDisplayMap,
  shouldShowCompletionPercent,
  shouldShowProgressAndTotal,
  unachievedLocaleMap,
  unachievedTargetDisplayMap,
} from '../../BadgeGoalLabel/BadgeGoalLabelConfig';

interface DetailGoalLabelProps {
  achieved: boolean;
  numberDone?: number;
  achievementName: AchievementName;
  points?: number;
  className?: string;
}

function achievementNameToGoalLocale(achieved = false, achievementName: AchievementName): string {
  return achieved ? achievedLocaleMap[achievementName] : unachievedLocaleMap[achievementName];
}

export const DetailGoalLabel: React.FC<DetailGoalLabelProps> = ({
  achieved,
  numberDone,
  achievementName,
  className,
}) => {
  const { t } = useTranslation();

  const total = achieved ? achievedTargetDisplayMap[achievementName] : unachievedTargetDisplayMap[achievementName];
  const showTotal = Boolean(achieved && total);
  const showProgressAndTotal = shouldShowProgressAndTotal.includes(achievementName);
  const showOfTotalFormat = showProgressAndTotal;
  const showNumberOfTotal =
    !achieved && typeof numberDone === 'number' && typeof total === 'number' && showProgressAndTotal;
  const badgeGoalLocale = achievementNameToGoalLocale(achieved, achievementName);

  const goalFontClass = showOfTotalFormat ? 'label-400' : 'label-900';
  return (
    <div className={classNames('flex flex-col items-center w-full', className)}>
      {showNumberOfTotal && (
        <div className="flex flex-col items-center text-center">
          <span className={classNames('display-500 text-text-info', 'text-primary-900')}>
            {shouldShowCompletionPercent.includes(achievementName)
              ? t('common.percent', { percent: numberDone })
              : numberDone}
          </span>
        </div>
      )}
      {achieved ? (
        <div className="flex flex-col items-center text-center">
          {showTotal && (
            <div className={classNames('text-info-600', 'display-500')}>
              {shouldShowCompletionPercent.includes(achievementName)
                ? t('common.percent', { percent: total })
                : total}
            </div>
          )}
          <span className={classNames(goalFontClass, 'w-full')}>
            {showOfTotalFormat && total ? (
              <>
                {shouldShowCompletionPercent.includes(achievementName)
                  ? t('common.ofNumberPercent', { number: total })
                  : t('common.ofNumber', { number: total })}{' '}
                {t(`badge.goal.${badgeGoalLocale}`)}
              </>
            ) : (
              t(`badge.goal.${badgeGoalLocale}`)
            )}
          </span>
        </div>
      ) : (
        <span className={classNames(goalFontClass)}>
          {showOfTotalFormat && total ? (
            <>
              {shouldShowCompletionPercent.includes(achievementName)
                ? t('common.ofNumberPercent', { number: total })
                : t('common.ofNumber', { number: total })}{' '}
              {t(`badge.goal.${badgeGoalLocale}`)}
            </>
          ) : (
            t(`badge.goal.${badgeGoalLocale}`)
          )}
        </span>
      )}
    </div>
  );
};
